import React from "react";
import { Box } from "@mui/material";

interface Props {
  weatherCode?: number;
  size?: number;
}

const wmoToWwoMap = {
  0: 113, // Clear sky -> Clear/Sunny
  1: 116, // Mainly clear, partly cloudy -> Partly Cloudy
  2: 119, // Partly cloudy -> Cloudy
  3: 122, // Overcast -> Overcast

  45: 248, // Fog -> Fog
  48: 260, // Depositing rime fog -> Freezing fog

  51: 266, // Drizzle Light -> Light drizzle
  53: 296, // Drizzle Moderate -> Light rain
  55: 299, // Drizzle Dense -> Moderate rain at times

  56: 281, // Freezing Drizzle Light -> Freezing drizzle
  57: 284, // Freezing Drizzle Dense -> Heavy freezing drizzle

  61: 293, // Rain Slight -> Patchy light rain
  63: 302, // Rain Moderate -> Moderate rain
  65: 308, // Rain Heavy -> Heavy rain

  66: 311, // Freezing Rain Light -> Light freezing rain
  67: 314, // Freezing Rain Heavy -> Moderate or Heavy freezing rain

  71: 323, // Snow Slight -> Patchy light snow
  73: 332, // Snow Moderate -> Moderate snow
  75: 338, // Snow Heavy -> Heavy snow

  77: 326, // Snow grains -> Light snow

  80: 353, // Rain showers Slight -> Light rain shower
  81: 356, // Rain showers Moderate -> Moderate or heavy rain shower
  82: 359, // Rain showers Violent -> Torrential rain shower

  85: 368, // Snow showers Slight -> Light snow showers
  86: 371, // Snow showers Heavy -> Moderate or heavy snow showers

  95: 386, // Thunderstorm Slight or moderate -> Patchy light rain in area with thunder
  96: 392, // Thunderstorm slight hail -> Patchy light snow in area with thunder
  99: 395, // Thunderstorm heavy hail -> Moderate or heavy snow in area with thunder
};

const WeatherIcon: React.FC<Props> = ({ weatherCode, size = 50 }) => {
  const weatherUrl =
    weatherCode !== undefined && weatherCode !== null
      ? `/static/weather_icons/${wmoToWwoMap[weatherCode as keyof typeof wmoToWwoMap]}.svg`
      : "/static/weather_icons/CloudOffOutlined.svg";

  return (
    <Box
      component="img"
      src={weatherUrl}
      sx={{
        width: size,
        height: size,
        objectFit: "contain",
        mr: weatherCode ? ".125rem" : ".25rem",
      }}
    />
  );
};

export default WeatherIcon;
